module.exports = __webpack_public_path__ + "img/logo-mobile.f0888c43.png";